module.exports = __webpack_public_path__ + "static/media/profile-my-order-red.864d6b44.svg";